import { isEqual } from 'lodash';

let previousParams: any = null;

export const isSameRequestParams = (newParams: any): boolean => {
  const areParamsEqual = isEqual(previousParams, newParams);

  if (!areParamsEqual) {
    previousParams = JSON.parse(JSON.stringify(newParams));
  }

  return areParamsEqual;
};
